var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"spinner-border",class:`spinner-border-${_vm.size}`})
}
var staticRenderFns = []

export { render, staticRenderFns }